import { render } from "./TerminalEmulator.vue?vue&type=template&id=bc9cfd12"
import script from "./TerminalEmulator.vue?vue&type=script&lang=js"
export * from "./TerminalEmulator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/drusha/Desktop/drusha computer/drusha-computer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__